import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Grid = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
`

export const GridItem = styled.div`
  display:flex;
  flex-direction:column;
`

export const GridItemTitle = styled.div`
  font-family: Roboto;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: white;  
  padding-left: 7px;
  `
export const GridImage = styled.img`
  object-fit: contain;
  padding: 5px;
`